import React from "react";
import { motion } from "framer-motion";
import img1 from "../assets/group-1.png";
import img2 from "../assets/group-2.png";

import icon_1 from "../assets/circle-icons/1.png";
import icon_2 from "../assets/circle-icons/2.png"
import icon_3 from "../assets/circle-icons/3.png"
import icon_4 from "../assets/circle-icons/4.png"
import icon_5 from "../assets/circle-icons/5.png"
import icon_6 from "../assets/circle-icons/6.png"




import RotatingCircle from "../components/RotatingCircle ";
import { Helmet } from "react-helmet-async";
// const icons = [
//   { src: icon_1, alt: "User||Registration" },
//   { src: icon_2, alt: "Different Acess||Levels" },
//   { src: icon_3, alt: "Statistics Per ||Customer,Per Location||& Per Game" },
//   { src: icon_4, alt: "Logistic Panel for||license renewal" },
//   { src: icon_5, alt: "Reports in||.pdf & .csv" },
//   { src: icon_6, alt: "Accounting||Results" },
// ];

const ManagementSoftware = () => {
  return (
    <div className="mt-8  lg:mt-16 py-6 lg:py-14 bg-[#eeeeee] ">
      <Helmet>
        <title>Advanced Management Software for Slot Game | Fusion Spin</title>
        <meta
          name="description"
          content="Discover advanced management software for slot games with Fusion Spin. Optimize operations and performance with efficient, innovative management tools."
        />
        <meta
          name="keywords"
          content="Slot Game Management Software, slot game services, slot game outsourcing, Fusion Spin, slot game solutions, custom slot machines, casino game development"
        />
      </Helmet>
      {/* Title and Description */} 
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="md:text-center lg:mb-12"
      >
        <h2 className="text-3xl md:text-[2.71rem] font-bold text-gray-800">Management Software</h2>
        <p className=" text-start lg:text-base text-[14px] md:text-[18px] poppins-font2 text-gray-600 md:px-8 px-4  lg:px-20 pt-4">
        We provide a complete management software solution designed to streamline client registration, financial management, and statistical analysis—all integrated with our slot games.
        Our system empowers operators and clients to track results weekly easily, ensuring transparent and efficient operations. Additionally, our games operate as standalone solutions, with licenses conveniently renewed through our website.
        Experience a more organized and insightful way to manage your slot gaming operations with our cutting-edge management software.

        </p>
    
      </motion.div>

      {/* Content Section */}
    <div className="flex flex-col md:flex-row items-center gap-6 px-4 sm:px-10 md:px-20 lg:px-10 pt-6">
  
  {/* Left Circular Features */}
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="w-full md:w-1/2 flex justify-center"
  >
    <img 
      src={img1} 
      alt="Fusion Spin Slots Software" 
      title="Fusion Spin Slots Software"
      className="w-full max-w-[550px] object-contain"
    />
  </motion.div> 

  {/* Right Responsive Dashboard */}
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="w-full md:w-1/2 flex justify-center"
  >
    <img
      src={img2}
      alt="Land-Based Slot Gaming"
      title="Land-Based Slot Gaming"
      className="w-full max-w-[550px] object-contain"
    />
  </motion.div>

</div>


    </div>
  );
};

export default ManagementSoftware;
